export const km = 'km';
export const mi = 'mi';
export const milesToKmMultiplier = 1.609;
